import * as React from "react";
import { IContextualMenuItem, CommandBar, ICommandBarItemProps } from "office-ui-fabric-react";
import { Language, Product } from "typings";
import { getStatusText } from "~/util/productStatus";
import * as G from "~/components/global.style";

export interface Props
{
    languages: Language[];
    product: Product;
    onStatusChange: (status: number) => void;
    onRemoveClick: () => void;
}

interface State
{
    language: string;
}

class Menu extends React.Component<Props, State>
{
    componentWillMount() 
    {
        const { languages } = this.props;
        if (languages && languages.length > 0)
        {
            this.setState( { language: languages[0].name });
        }
    }

    componentWillReceiveProps(nextProps: Props)
    {
        const { languages } = nextProps;
        if (this.state && this.state.language !== undefined && languages && languages.length > 0)
        {
            this.setState( { language: languages[0].name });
        }
    }

    onLanguageClick = (language: string) =>
    {
        this.setState({ language });
    }

    onStatusChange = (ev?: React.MouseEvent<HTMLElement>, item?: IContextualMenuItem) =>
    {
        if (item)
        {
            this.props.onStatusChange(parseInt(item.key));
        }
        
    }

    render()
    {
        const { languages, product, onRemoveClick } = this.props;
        if (!languages || languages.length === 0)
        {
            return null;
        }
        const items: ICommandBarItemProps[] = [];
        if (product.parentId === null)
        {
            //items = [
            //    {
            //        key: "variants",
            //        name: `Add variants`,
            //        href: `/products/${product.id}`
            //    }
            //];
        }
        const status = getStatusText(product.status);
        const rightMenu: ICommandBarItemProps[] = [
            { 
                key: "Status",
                name: `Status (${status})`,
                className: `status-${status}`,
                iconProps: {
                    iconName: "StatusCircleInner"
                    
                },
                subMenuProps: {
                    items: [
                        { key: "0", name: "New", onClick: this.onStatusChange, 
                        iconProps: {iconName: "StatusCircleInner", style: {color: G.ColorUnAvailable}}},
                        { key: "1", name: "Working", onClick: this.onStatusChange, 
                        iconProps: {iconName: "StatusCircleInner", style: {color: G.ColorWaiting}}},
                        { key: "16", name: "Ready", onClick: this.onStatusChange, 
                        iconProps: {iconName: "StatusCircleInner", style: {color: G.ColorAvailable}}},
                        { key: "2", name: "Discontinued", onClick: this.onStatusChange, 
                        iconProps: {iconName: "StatusCircleInner", style: {color: G.ColorUnAvailable}}},
                    ],
                },
            },
            {
                key: "remove",
                name: `Remove`,
                onClick: onRemoveClick
            }
        ];
        return <div>
            <CommandBar items={items} farItems={rightMenu} />
        </div>;
    }
}

export default Menu;


// WEBPACK FOOTER //
// ./src/components/product/product/Menu.tsx